<template>
  <div class="intelligence-thinking" role="status" aria-label="ProApp Intelligence is thinking">
    <div class="intelligence-thinking__avatar">
      <img src="/favicon-32x32.png" alt="" aria-hidden="true" />
    </div>
    <div class="intelligence-thinking__bubble" aria-hidden="true">
      <span />
      <span />
      <span />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProAppIntelligenceThinkingMessage',
}
</script>

<style lang="scss" scoped>
.intelligence-thinking {
  display: flex;
  align-items: flex-end;
  gap: 8px;

  &__avatar {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: white;
    box-shadow: 0 3px 4px rgba(133, 133, 133, 0.2);

    img {
      width: 21px;
      height: 21px;
    }
  }

  &__bubble {
    min-width: 58px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    border-radius: 20px 20px 20px 4px;
    background: var(--v-secondary-lighten4);

    span {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: var(--v-primary-base);
      animation: intelligence-dot 1.1s infinite ease-in-out;

      &:nth-child(2) {
        animation-delay: 0.14s;
      }

      &:nth-child(3) {
        animation-delay: 0.28s;
      }
    }
  }
}

@keyframes intelligence-dot {
  0%,
  60%,
  100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .intelligence-thinking__bubble span {
    animation: none;
    opacity: 0.7;
  }
}
</style>
